export const cookieConfig = {
  samesiteLax: 'samesite=lax',
};
